import { endPoint } from 'app/config/axios/customAxios';

function cmsRequest({ api, locale, projectName = 'controlpanel' }) {
  const BASE_URL_CMS = process.env.REACT_APP_CMS_GATEWAY_URL;

  let url;
  if (projectName === '') {
    url = `${BASE_URL_CMS}${api}`;
    if (url.includes('?')) {
      url += `&locale=${locale}`;
    } else {
      url += `?locale=${locale}`;
    }
  } else {
    url = `${BASE_URL_CMS}${projectName}/${api}`;
    if (url.includes('?')) {
      url += `&locale=${locale}`;
    } else {
      url += `?locale=${locale}`;
    }
  }

  if (
    process.env.REACT_APP_ENVIRONMENT !== 'production' &&
    !url.includes('preview=true')
  ) {
    url += `&preview=true`;
  }

  return endPoint.request(url);
}

export default cmsRequest;
